import { render, staticRenderFns } from "./Packings.vue?vue&type=template&id=47aa3086&"
import script from "./Packings.vue?vue&type=script&lang=js&"
export * from "./Packings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports